'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = 'M176 64l0 32 96 0 0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zM128 96l0-32c0-53 43-96 96-96s96 43 96 96l0 32 128 0 0 80-48 0 0-32-352 0 0 256 96 0 0 48-144 0 0-352 128 0zM576 224l0 288-384 0 0-288 384 0zM336 312l0-24-48 0 0 64c0 53 43 96 96 96s96-43 96-96l0-64-48 0 0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;